import React from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { frameImageUrlsAtom } from '../../../labelling-v2/atoms/frame-image-urls-atom';
import { currentFrameAtom } from '../../../labelling-v2/atoms/video-playback-atoms';
import { useMediaStateMediaFrameLoadStatus } from '../../providers/hooks/use-media-state';
import { useFramesToDownload } from '../frames-control-panel/frames-timeline/hooks/use-next-frame-for-download';
const HiddenImage = styled('img', {
  height: '0',
  width: '0',
  display: 'none'
});
type Props = {
  setImageLoadedStatus: (index: number) => void;
};
const FrameFetcher = ({
  setImageLoadedStatus
}: Props) => {
  const currentFrame = useAtomValue(currentFrameAtom);
  const frameImageUrls = useAtomValue(frameImageUrlsAtom);
  const mediaFrameLoadStatus = useMediaStateMediaFrameLoadStatus();
  const lastFrameThatCanBeDownloaded = useFramesToDownload(currentFrame, mediaFrameLoadStatus);
  return <>
      {frameImageUrls.map((imageUrl, index) => {
      if (index > lastFrameThatCanBeDownloaded || index < currentFrame) {
        return null;
      }
      return <HiddenImage key={`frame_${imageUrl}_${index}`} alt={`frame_${index}`} src={imageUrl} onLoad={() => setImageLoadedStatus(index)} onError={() => setImageLoadedStatus(index)} />;
    })}
    </>;
};
export default FrameFetcher;